import React from 'react';

import { LoadingHeader } from '@lumapps/header/components/LoadingHeader';

const CLASSNAME = 'header-top';
const Loading = () => <LoadingHeader className={CLASSNAME} />;

export default Loading;
